/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NgxTextDecoratorDirective as Éµa} from './lib/ngx-text-decoration.directive';